var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMerchantManagePlatform(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1.49623,
    y: -0.997692,
    width: 17.6157,
    height: 17.6157
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.08px)",
      clipPath: "url(#bgblur_0_9308_7432_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 2.16395,
    d: "M8.46257 1.32255L3.07543 2.76603C1.11228 3.29205 0.298007 4.70227 0.823983 6.66523L2.26595 12.0467C2.79193 14.0097 4.20222 14.8238 6.16537 14.2978L11.5525 12.8543C13.5157 12.3283 14.3248 10.9195 13.7988 8.95651L12.3569 3.57501C11.8309 1.61204 10.4257 0.796524 8.46257 1.32255Z",
    fill: "url(#paint0_linear_9308_7432)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_9308_7432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1169 8.37523L10.1386 4.66951C9.78375 3.32534 8.89564 2.72264 7.72789 3.03092L3.77284 4.07502C2.58594 4.38835 2.12635 5.34684 2.4812 6.691L3.45949 10.3967C3.82005 11.7626 4.68702 12.3472 5.87391 12.0339L9.82896 10.9898C10.9967 10.6815 11.4775 9.74106 11.1169 8.37523Z",
    fill: "#FF5563"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 1.72213,
    y: 1.19796,
    width: 17.2652,
    height: 17.2652
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.25px)",
      clipPath: "url(#bgblur_1_9308_7432_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.49687
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_9308_7432",
    maskUnits: "userSpaceOnUse",
    x: 3.3855,
    y: 2.86133,
    width: 14,
    height: 14,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 3.3855,
    y: 2.86133,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1458 3.86133L7.56912 3.86133C5.53691 3.86133 4.3855 5.01274 4.3855 7.04495V12.6163C4.3855 14.6485 5.53691 15.7999 7.56912 15.7999H13.1458C15.178 15.7999 16.3241 14.6485 16.3241 12.6163V7.04495C16.3241 5.01274 15.178 3.86133 13.1458 3.86133Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.1458 3.86133L7.56912 3.86133C5.53691 3.86133 4.3855 5.01274 4.3855 7.04495V12.6163C4.3855 14.6485 5.53691 15.7999 7.56912 15.7999H13.1458C15.178 15.7999 16.3241 14.6485 16.3241 12.6163V7.04495C16.3241 5.01274 15.178 3.86133 13.1458 3.86133Z",
    fill: "#FF3949",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1458 4.02779C13.2377 4.02779 13.3122 3.95326 13.3122 3.86133C13.3122 3.7694 13.2377 3.69487 13.1458 3.69487V4.02779ZM13.1458 3.69487C13.0538 3.69487 12.9793 3.7694 12.9793 3.86133C12.9793 3.95326 13.0538 4.02779 13.1458 4.02779V3.69487ZM13.1458 3.86133V3.69487L7.56912 3.69487V3.86133V4.02779H13.1458V3.86133ZM7.56912 3.86133V3.69487C6.52207 3.69487 5.67886 3.99202 5.09753 4.57336C4.51619 5.15469 4.21904 5.9979 4.21904 7.04495H4.3855H4.55196C4.55196 6.05979 4.83051 5.31119 5.33293 4.80876C5.83536 4.30634 6.58396 4.02779 7.56912 4.02779V3.86133ZM4.3855 7.04495H4.21904V12.6163H4.3855H4.55196V7.04495H4.3855ZM4.3855 12.6163H4.21904C4.21904 13.6633 4.51619 14.5066 5.09753 15.0879C5.67886 15.6692 6.52207 15.9664 7.56912 15.9664V15.7999V15.6335C6.58396 15.6335 5.83536 15.3549 5.33293 14.8525C4.83051 14.3501 4.55196 13.6015 4.55196 12.6163H4.3855ZM7.56912 15.7999V15.9664H13.1458V15.7999V15.6335H7.56912V15.7999ZM13.1458 15.7999V15.9664C14.1928 15.9664 15.0348 15.6692 15.6149 15.0877C16.1948 14.5063 16.4905 13.6631 16.4905 12.6163H16.3241H16.1576C16.1576 13.6017 15.8803 14.3503 15.3792 14.8526C14.8781 15.3549 14.1309 15.6335 13.1458 15.6335V15.7999ZM16.3241 12.6163H16.4905V7.04495H16.3241H16.1576V12.6163H16.3241ZM16.3241 7.04495H16.4905C16.4905 5.99811 16.1948 5.15491 15.6149 4.5735C15.0348 3.99203 14.1928 3.69487 13.1458 3.69487V3.86133V4.02779C14.1309 4.02779 14.8781 4.30633 15.3792 4.80862C15.8803 5.31097 16.1576 6.05959 16.1576 7.04495H16.3241Z",
    fill: "url(#paint1_linear_9308_7432)",
    mask: "url(#path-3-outside-1_9308_7432)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 4.60006,
    y: 3.80538,
    width: 11.515,
    height: 12.0455
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.25px)",
      clipPath: "url(#bgblur_2_9308_7432_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_9308_7432)",
    "data-figma-bg-blur-radius": 2.49687
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_9308_7432",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.376 6.30225C10.1054 6.30225 9.8825 6.5251 9.8825 6.80101V12.8605C9.8825 13.1311 10.1054 13.354 10.376 13.354C10.6519 13.354 10.8747 13.1311 10.8747 12.8605V6.80101C10.8747 6.5251 10.6519 6.30225 10.376 6.30225ZM7.59039 8.26032C7.31978 8.26032 7.09692 8.48317 7.09692 8.75909V12.8607C7.09692 13.1313 7.31978 13.3541 7.59039 13.3541C7.8663 13.3541 8.08915 13.1313 8.08915 12.8607V8.75909C8.08915 8.48317 7.8663 8.26032 7.59039 8.26032ZM12.626 10.9238C12.626 10.6479 12.8488 10.4251 13.1248 10.4251C13.3954 10.4251 13.6182 10.6479 13.6182 10.9238V12.8606C13.6182 13.1312 13.3954 13.354 13.1195 13.354C12.8488 13.354 12.626 13.1312 12.626 12.8606V10.9238Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.376 6.30225C10.1054 6.30225 9.8825 6.5251 9.8825 6.80101V12.8605C9.8825 13.1311 10.1054 13.354 10.376 13.354C10.6519 13.354 10.8747 13.1311 10.8747 12.8605V6.80101C10.8747 6.5251 10.6519 6.30225 10.376 6.30225ZM7.59039 8.26032C7.31978 8.26032 7.09692 8.48317 7.09692 8.75909V12.8607C7.09692 13.1313 7.31978 13.3541 7.59039 13.3541C7.8663 13.3541 8.08915 13.1313 8.08915 12.8607V8.75909C8.08915 8.48317 7.8663 8.26032 7.59039 8.26032ZM12.626 10.9238C12.626 10.6479 12.8488 10.4251 13.1248 10.4251C13.3954 10.4251 13.6182 10.6479 13.6182 10.9238V12.8606C13.6182 13.1312 13.3954 13.354 13.1195 13.354C12.8488 13.354 12.626 13.1312 12.626 12.8606V10.9238Z",
    fill: "url(#paint2_linear_9308_7432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8825 6.80101H9.94908C9.94908 6.56141 10.1426 6.36883 10.376 6.36883V6.30225V6.23566C10.0681 6.23566 9.81592 6.48879 9.81592 6.80101H9.8825ZM9.8825 12.8605H9.94908V6.80101H9.8825H9.81592V12.8605H9.8825ZM10.376 13.354V13.2874C10.1421 13.2874 9.94908 13.0943 9.94908 12.8605H9.8825H9.81592C9.81592 13.1679 10.0686 13.4206 10.376 13.4206V13.354ZM10.8747 12.8605H10.8081C10.8081 13.0939 10.6156 13.2874 10.376 13.2874V13.354V13.4206C10.6882 13.4206 10.9413 13.1684 10.9413 12.8605H10.8747ZM10.8747 6.80101H10.8081V12.8605H10.8747H10.9413V6.80101H10.8747ZM10.376 6.30225V6.36883C10.6151 6.36883 10.8081 6.56187 10.8081 6.80101H10.8747H10.9413C10.9413 6.48833 10.6886 6.23566 10.376 6.23566V6.30225ZM7.09692 8.75909H7.16351C7.16351 8.51948 7.35701 8.3269 7.59039 8.3269V8.26032V8.19373C7.28254 8.19373 7.03034 8.44686 7.03034 8.75909H7.09692ZM7.09692 12.8607H7.16351V8.75909H7.09692H7.03034V12.8607H7.09692ZM7.59039 13.3541V13.2875C7.35655 13.2875 7.16351 13.0945 7.16351 12.8607H7.09692H7.03034C7.03034 13.168 7.283 13.4207 7.59039 13.4207V13.3541ZM8.08915 12.8607H8.02257C8.02257 13.094 7.82999 13.2875 7.59039 13.2875V13.3541V13.4207C7.90261 13.4207 8.15574 13.1685 8.15574 12.8607H8.08915ZM8.08915 8.75909H8.02257V12.8607H8.08915H8.15574V8.75909H8.08915ZM7.59039 8.26032V8.3269C7.82953 8.3269 8.02257 8.51994 8.02257 8.75909H8.08915H8.15574C8.15574 8.4464 7.90307 8.19373 7.59039 8.19373V8.26032ZM13.1248 10.4251V10.3585C12.8121 10.3585 12.5594 10.6112 12.5594 10.9238H12.626H12.6926C12.6926 10.6847 12.8856 10.4917 13.1248 10.4917V10.4251ZM13.6182 10.9238H13.6848C13.6848 10.6116 13.4326 10.3585 13.1248 10.3585V10.4251V10.4917C13.3581 10.4917 13.5516 10.6842 13.5516 10.9238H13.6182ZM13.6182 12.8606H13.6848V10.9238H13.6182H13.5516V12.8606H13.6182ZM13.1195 13.354V13.4206C13.4317 13.4206 13.6848 13.1684 13.6848 12.8606H13.6182H13.5516C13.5516 13.0939 13.3591 13.2874 13.1195 13.2874V13.354ZM12.626 12.8606H12.5594C12.5594 13.1679 12.8121 13.4206 13.1195 13.4206V13.354V13.2874C12.8856 13.2874 12.6926 13.0944 12.6926 12.8606H12.626ZM12.626 10.9238H12.5594V12.8606H12.626H12.6926V10.9238H12.626Z",
    fill: "url(#paint3_linear_9308_7432)",
    mask: "url(#path-5-inside-2_9308_7432)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7432_clip_path",
    transform: "translate(1.49623 0.997692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.46257 1.32255L3.07543 2.76603C1.11228 3.29205 0.298007 4.70227 0.823983 6.66523L2.26595 12.0467C2.79193 14.0097 4.20222 14.8238 6.16537 14.2978L11.5525 12.8543C13.5157 12.3283 14.3248 10.9195 13.7988 8.95651L12.3569 3.57501C11.8309 1.61204 10.4257 0.796524 8.46257 1.32255Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_9308_7432",
    x: 0.200306,
    y: 0.787953,
    width: 13.198,
    height: 13.4925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.08198,
    result: "effect1_foregroundBlur_9308_7432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7432_clip_path",
    transform: "translate(-1.72213 -1.19796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1458 3.86133L7.56912 3.86133C5.53691 3.86133 4.3855 5.01274 4.3855 7.04495V12.6163C4.3855 14.6485 5.53691 15.7999 7.56912 15.7999H13.1458C15.178 15.7999 16.3241 14.6485 16.3241 12.6163V7.04495C16.3241 5.01274 15.178 3.86133 13.1458 3.86133Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_9308_7432",
    x: 4.60006,
    y: 3.80538,
    width: 11.515,
    height: 12.0455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.832289,
    dy: 0.832289
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.832289
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.447059 0 0 0 0 0.368627 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7432"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7432",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_9308_7432_clip_path",
    transform: "translate(-4.60006 -3.80538)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.376 6.30225C10.1054 6.30225 9.8825 6.5251 9.8825 6.80101V12.8605C9.8825 13.1311 10.1054 13.354 10.376 13.354C10.6519 13.354 10.8747 13.1311 10.8747 12.8605V6.80101C10.8747 6.5251 10.6519 6.30225 10.376 6.30225ZM7.59039 8.26032C7.31978 8.26032 7.09692 8.48317 7.09692 8.75909V12.8607C7.09692 13.1313 7.31978 13.3541 7.59039 13.3541C7.8663 13.3541 8.08915 13.1313 8.08915 12.8607V8.75909C8.08915 8.48317 7.8663 8.26032 7.59039 8.26032ZM12.626 10.9238C12.626 10.6479 12.8488 10.4251 13.1248 10.4251C13.3954 10.4251 13.6182 10.6479 13.6182 10.9238V12.8606C13.6182 13.1312 13.3954 13.354 13.1195 13.354C12.8488 13.354 12.626 13.1312 12.626 12.8606V10.9238Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7432",
    x1: 10.2,
    y1: 3.55996,
    x2: 1.19741,
    y2: 11.5197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7432",
    x1: 6.28593,
    y1: 5.25219,
    x2: 13.9015,
    y2: 14.6842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9308_7432",
    x1: 5.40891,
    y1: 11.5363,
    x2: 8.46372,
    y2: 17.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9308_7432",
    x1: 8.13499,
    y1: 7.1238,
    x2: 12.6946,
    y2: 12.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantManagePlatform);
export default __webpack_public_path__ + "static/media/merchantManagePlatform.829fd2b2fece05cd1bb4b74eed4263f8.svg";
export { ForwardRef as ReactComponent };